var registerFormButton = $('.js-form-button');
var registerForm = $('.js-register-form');

function formSubmission(gameUrlDesktop, gameUrlMobile) {
    $('.js-register-form').addClass('loading');
    $('.loader').addClass('show');

    $.ajax({
        type: 'POST',
        url: AJAX_URL,
        dataType: 'json',
        data: {
            action: 'handleRegistration',
            firstName: $('.js-register-form').find($('.js-form-firstname')).val(),
            surname: $('.js-register-form').find($('.js-form-surname')).val(),
            title: $('.js-register-form').find($('.js-form-title')).val(),
            email: $('.js-register-form').find($('.js-form-email')).val(),
            company: $('.js-register-form').find($('.js-form-company')).val(),
        },
        success: function(data) {
            $('.js-register-form').removeClass('loading');
            $('.js-register-form').addClass('hide');
            $('.loader').removeClass('show');
            $('.registration-form__complete').addClass('show');
            $('.registration-form__complete-name').text(data.firstName + ' ' + data.surname);

            var setGameUrl = '';

            setTimeout(function() {
                if (!userAgentIsMobile()) {
                    setGameUrl = gameUrlDesktop;
                } else {
                    setGameUrl = gameUrlMobile;
                }

                var sanitizedBusinessName = data.company.replace(/[_\W]+/g, "");
                var sanitizedName = data.firstName.replace(/[_\W]+/g, "") + data.surname.replace(/[_\W]+/g, "");
                var sanitizedTitle = data.title.replace(/[_\W]+/g, "");

                window.location = setGameUrl + sanitizedName + '_' + sanitizedTitle + '_' + sanitizedBusinessName;
            }, 3000);
        },
        error: function () {
            $('.loader').removeClass('show');
            $('.js-register-form').removeClass('loading');
            $('.registration-form__error').addClass('show');
        }
    });
}

function userAgentIsMobile() {
    if (navigator.userAgent.match(/Android/i)
    || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i)
    || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i)) {
        return true;
    } else {
        return false;
    }
}

function formCheck(gameUrlDesktop, gameUrlMobile) {
    var fields = $('.js-register-form').find('input[type="text"], input[type="email"]').serializeArray();
    var hasEmptyFields = false;

    $.each(fields, function(i, field) {
        if (!field.value) {
            $('input[name="'+ field.name +'"]').addClass('is-required');
            hasEmptyFields = true;
        } else {
            $('input[name="'+ field.name +'"]').removeClass('is-required');
        }
    });

    if (hasEmptyFields) {
        return;
    } else {
        formSubmission(gameUrlDesktop, gameUrlMobile);
    }
}

$('.js-form-accept').on('click', function() {
    if ($(this).is(':checked')) {
        registerFormButton.prop('disabled', false);
    } else {
        registerFormButton.prop('disabled', true);
    }
});

registerFormButton.on('click', function() {
    formCheck($(this).data("game-url-desktop"), $(this).data("game-url-mobile"));
});
